export const getters = {
  getCompanies($state) {
    return $state.sortOrder.map(companyId => $state.records[companyId]);
  },
  getWalletCompanies($state) {
    return $state.walletSortOrder.map(companyId => $state.walletRecords[companyId]);
  },
  getCompany: $state => id => {
    return $state.records[id] || $state.walletRecords[id] || {};
  },
  getCurrentCompany($state) {
    return $state.currentCompany;
  },
  getCompanyAssociations($state) {
    return $state.associations;
  },
  getCompanyContacts($state) {
    return $state.associations.contacts;
  },
  getRelatedCompanies($state) {
    return $state.associations.relatedCompanies;
  },
  getCompanyNotes($state) {
    return [...$state.notes.data].sort((noteA, noteB) => noteB.updated_at - noteA.updated_at);
  },
  getCompanyNotesMeta($state) {
    return $state.notes.meta;
  },
  getCompanyActivityEvents($state) {
    return $state.activityEvents.data;
  },
  getCompanyActivityEventsMeta($state) {
    return $state.activityEvents.meta;
  },
  getCompanyTasks($state) {
    return $state.tasks;
  },
  getMeta($state) {
    return $state.meta;
  },
  getWalletMeta($state) {
    return $state.walletMeta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getProfileUIFlags($state) {
    return $state.profileUiFlags;
  },
  getSelectedCompanyIds($state) {
    return $state.selectedCompanyIds;
  },
  getAppliedCompanyFilters($state) {
    return $state.appliedFilters;
  },
};
